// extracted by mini-css-extract-plugin
module.exports = {"textAreaWrapper":"styles_textAreaWrapper__3t52C","textAreaLabel":"styles_textAreaLabel__1TcJu"};